import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import OrderDetails from './components/OrderDetails';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { LinearProgress, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button as MuiButton, Typography, Box, IconButton } from '@mui/material';
import DatePicker from 'react-datepicker';
import renderDateTimePickerField from 'src/shared/components/form/DateTimePicker';
import { Link } from '@mui/material';
import RiderLocationMapModal from 'src/containers/PnD/RiderLocationHistory/View/components/RiderLocationMapModal';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Badge from "react-bootstrap/Badge";
import ScheduleIcon from '@mui/icons-material/Schedule';
import PageHeader from 'src/shared/components/layout/PageHeader';
import {
  HUB_MANAGER_ROLE_ID,
  OPERATION_TYPE_FOR_RE_RESCHEDULE,
  ERROR_MESSAGES
} from '../../../../utils/pnd/PndConstants';
import { showNotification, successNofication } from 'src/shared/components/Notification';
import OrderTrackingModal from 'src/containers/PnD/Views/OrderView/OrderTrackingView/OrderTrackingModal';
import PreviewIcon from '@mui/icons-material/Preview';
import OrderDetailsShippingViewDetailsModal from './components/OrderDetailsShippingViewDetailsModal';

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { formatDate } from '../../../../utils/DateUtils';
import { Redirect } from 'react-router-dom';
const OrderDetailsIndex = () => {

  const [isRedirect, setRedirect] = useState(false);
  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);

  const [isGoogleMapView, setGoogleMapView] = useState(null);
  const [isOrderId, setOrderId] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isStatusProgress, setStatusProgress] = useState(false);
  const [isLocation, setLocation] = useState({ latitude: null, longitude: null });
  const [newRequestedDate, setNewRequestedDate] = useState("");
  const [newScheduledDate, setNewScheduledDate] = useState("");

  useEffect(() => {
    getAllOrderDetails();
  }, [])
  const getAllOrderDetails = async () => {
    try {
      setLoading(true);

      const response = await PndRestApi.GetUndeliveredOrderDetails();
      if (response.status === 200 && response.data.status === 200) {
        if (HUB_MANAGER_ROLE_ID == localStorage.getItem("uri")) {
          setReactTableData({ tableHeaderData: HubMangerColumns, tableRowsData: response.data.data });
        }

      } else if (response?.data?.status && response?.data?.status === 204) {
        setNoRecordFound(true);

      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };




  const HubMangerColumns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1,
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 50,
        Cell: ({ row }) => <span style={{ fontWeight: 600, color: '#64748b' }}>{row.index + 1}</span>,
      },
      {
        Header: 'Action',
        accessor: 'edit',
        disableSortBy: true,
        width: 100,
        Cell: row => (
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <Tooltip title="View Order Details" arrow>
              <IconButton
                size="small"
                onClick={() => viewDetails(row.row.original)}
                color="primary"
                sx={{ bgcolor: '#e0f2fe', '&:hover': { bgcolor: '#bae6fd' } }}
              >
                <PreviewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Re-Schedule Order" arrow>
              <IconButton
                size="small"
                onClick={() => showDialogBox(row.row.original)}
                color="success"
                sx={{ bgcolor: '#dcfce7', '&:hover': { bgcolor: '#bbf7d0' } }}
              >
                <AssignmentIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </div>
        ),
      },
      {
        Header: 'Order No.',
        accessor: 'orderNo',
        Cell: ({ value }) => <span style={{ fontWeight: 700, color: '#1e293b' }}>{value || '—'}</span>,
      },
      {
        Header: 'ERP Order No.',
        accessor: 'erpOrderNo',
        Cell: ({ row }) => (
          <span style={{ fontWeight: 600, color: '#475569' }}>
            {row.original.erpOrderNo || '—'}
          </span>
        ),
      },
      {
        Header: "Order Type",
        accessor: "orderType",
        width: 80,
        Cell: ({ row }) => (
          <>
            {row.original.orderType === 1 ? (
              <Badge bg="success" className="px-2 py-1">DO</Badge>
            ) : row.original.orderType === 2 ? (
              <Badge bg="primary" className="px-2 py-1">PU</Badge>
            ) : (
              <Badge bg="warning" className="px-2 py-1">PnD</Badge>
            )}
          </>
        )
      },
      {
        Header: "Order Priority",
        accessor: "orderPriorityName",
        width: 80,
        Cell: ({ row }) => (
          <>
            {row.original.orderPriorityInfo?.orderPriorityId === 1 ? (
              <Badge bg="danger" className="px-2 py-1">EP</Badge>
            ) : row.original.orderPriorityInfo?.orderPriorityId === 2 ? (
              <Badge bg="warning" className="px-2 py-1">SD</Badge>
            ) : (
              <Badge bg="secondary" className="px-2 py-1">SH</Badge>
            )}
          </>
        )
      },
      {
        Header: 'Requested Date',
        accessor: 'requestedDateTimeSlot',
        Cell: ({ value }) => formatDate(value),
        disableGlobalFilter: true,
      },
      {
        Header: 'Scheduled Date',
        accessor: 'scheduledDateTimeSlot',
        Cell: ({ value }) => formatDate(value),
        disableGlobalFilter: true,
      },
      {
        Header: 'Dlv Location',
        accessor: 'areaName',
        Cell: row => (
          <Tooltip title="Click to view delivery area on map" arrow>
            <Link
              style={{ cursor: "pointer", color: '#2563eb', fontWeight: 500, textDecoration: 'none' }}
              onClick={() => openMap(row.row.original)}
            >
              {row.row.original?.areaName || '—'}
            </Link>
          </Tooltip>
        ),
      },
    ],
    [],
  );
  const openMap = async (event) => {
    if (event) {
      setLocation({ latitude: event?.latitude, longitude: event?.longitude });
      setTempData(event);
      setGoogleMapView(true);
    }
  }

  if (isRedirect) {
    //window.location.reload();  
    return <Redirect to="/web_app/pnd_order/order_details" />;
  }



  const closeDialog = () => {
    // Close confirmation dialog without performing unassignment
    setShowConfirmation(false);
  };

  const viewDetails = async (event) => {
    if (event?.orderId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("View-Order Details")
    }

  }

  const showDialogBox = async (event) => {
    if (event && event.orderRatsHistoryInfo === null) {
      showNotification(
        "theme-light",
        "ltr",
        "Warning",
        "Rescheduling is currently unavailable. The assigned rider is still processing other orders in the same trip. Please wait until the current trip is completed to reschedule this order. This ensures the rider's order history is preserved."
      );
      return;
    }
    setShowConfirmation(true);
    if (event?.orderId) {
      setTempData(event);
      setOrderId(event?.orderId);
      setNewRequestedDate(""); // clear previous date
      setNewScheduledDate(""); // clear previous scheduled date
    }
  }

  const OrderStatusUpdate = async () => {
    try {
      if (!newScheduledDate) {
        showNotification("theme-light", "ltr", "Error", "Please select scheduled date and time.");
        return;
      }
      if (new Date(newScheduledDate).getTime() < new Date().getTime()) {
        showNotification("theme-light", "ltr", "Error", "Past date and time are not allowed. Please select a future date and time.");
        return;
      }
      setLoading(true);
      setShowConfirmation(false);
      let Obj = {};
      Obj["operationType"] = OPERATION_TYPE_FOR_RE_RESCHEDULE;
      Obj["orderId"] = isOrderId;
     // Obj["requestedDateTimeSlot"] = new Date(newRequestedDate).toISOString();
      Obj["scheduledDateTimeSlot"] = new Date(newScheduledDate).toISOString();


      //window.alert(`You submitted:\n\n${JSON.stringify(Obj, null, 2)}`);
      const response = await PndRestApi.UpdateOrderStatusDetails(Obj);
      if (response.status === 200 && response.data.status === 200) {
        successNofication(
          "theme-light",
          "ltr",
          `Message: Order Status Updated Successfully`
        );
        setRedirect(true);
      } else
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );

    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <Container fluid style={{ maxWidth: '1400px' }}>
        <PageHeader
          icon={<ScheduleIcon fontSize="large" />}
          title="Order Reschedule"
          subtitle="All rider-requested rescheduled orders will be listed here. Based on the customer's request, please reschedule to a new date. Rescheduled orders will be listed in the Pick/Drop menu."
          gradient="linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)"
        />

        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

        {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && !isNoRecordFound && (
          <OrderDetails
            reactTableData={reactTableData}
            onReschedule={showDialogBox}
            onOpenMap={openMap}
          />
        )}
        {isNoRecordFound && (
          <OrderDetails
            isNoRecordFound={isNoRecordFound}
            onReschedule={showDialogBox}
            onOpenMap={openMap}
          />
        )}
     
        {isGoogleMapView && (
          <RiderLocationMapModal
            modalShow={isGoogleMapView}
            setModalShow={setGoogleMapView}
            data={isLocation}
          />
        )}

        {showConfirmation && (
          <Dialog
            open={showConfirmation}
            onClose={closeDialog}
            maxWidth="sm"
            fullWidth
            PaperProps={{
              sx: {
                borderRadius: '12px',
                overflow: 'visible',
                boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)'
              }
            }}
          >
            <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.25rem', pb: 1 }}>
              Reschedule Order
              <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                Please select the scheduled dates and time for this order.
              </Typography>
            </DialogTitle>
            <DialogContent dividers sx={{ py: 3, overflow: 'visible' }}>
              
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                {/* <Box>
                  <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#64748b', display: 'block', mb: 1 }}>
                    Requested Time *
                  </Typography>
                  {renderDateTimePickerField({ input: { value: newRequestedDate, onChange: setNewRequestedDate } })}
                </Box> */}
                <Box
                  sx={{
                    '& .form__form-group-datepicker': {
                      height: '40px',
                      padding: '6px 10px',
                      boxSizing: 'border-box',
                    },
                    '& .react-datepicker__day--disabled, & .react-datepicker__time-list-item--disabled': {
                      color: '#cbd5e1 !important',
                      cursor: 'not-allowed !important',
                    },
                  }}
                >
                  <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#64748b', display: 'block', mb: 1 }}>
                    New Scheduled Date Time *
                  </Typography>
                  <div className="date-picker">
                    <DatePicker
                      timeFormat="hh:mm aa"
                      className="form__form-group-datepicker"
                      selected={newScheduledDate ? new Date(newScheduledDate) : null}
                      onChange={(date) => {
                        if (date && date.getTime() < new Date().getTime()) {
                          const nextSlot = new Date();
                          const minutes = nextSlot.getMinutes();
                          nextSlot.setMinutes(minutes + (30 - (minutes % 30)), 0, 0);
                          setNewScheduledDate(nextSlot);
                        } else {
                          setNewScheduledDate(date);
                        }
                      }}
                      showTimeSelect
                      dateFormat="dd/MM/yyyy hh:mm aa"
                      dropDownMode="select"
                      popperClassName="date-picker"
                      popperPlacement="bottom-start"
                      minDate={new Date()}
                      filterTime={(time) => new Date().getTime() < new Date(time).getTime()}
                    />
                  </div>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
              <MuiButton onClick={closeDialog} color="secondary" variant="outlined" sx={{ textTransform: 'none', borderRadius: '6px' }}>
                Cancel
              </MuiButton>
              <MuiButton
                onClick={OrderStatusUpdate}
                color="primary"
                variant="contained"
                sx={{
                  textTransform: 'none',
                  borderRadius: '6px',
                  boxShadow: 'none',
                  '&:hover': { boxShadow: 'none' }
                }}
              >
                Confirm Reschedule
              </MuiButton>
            </DialogActions>
          </Dialog>
        )}

        {viewDetailPopup && (
          <OrderDetailsShippingViewDetailsModal
            modalShow={viewDetailPopup}
            setModalShow={setViewDetailPopup}
            dataInfo={temp}
            isTitle={isTitle}
          />
        )}

        {isStatusProgress && (
          <OrderTrackingModal
            modalShow={isStatusProgress}
            isOrderId={isOrderId}
            setModalShow={setStatusProgress}
          />
        )}
      </Container>
    </Box>
  );
};


const mapStateToProps = (state) => ({
  // tableData: state.transaction.datas,
  initialValues: {
    orderType: { value: 0, label: "All" }
  }
});
export default connect(mapStateToProps)(
  reduxForm({
    form: "OrderDetailsIndexForm",
    enableReinitialize: false,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
  })(OrderDetailsIndex)
);

